export default function filterMemories({ memories, memoryType }) {
  const filteredMemories = []
  memories.sourceDescriptions.forEach((sources) => {
    const contributor = sources?.attribution?.contributor?.resourceId
    if (sources.mediaType.slice(0, 5).toLowerCase() === 'image' && memoryType === 'image') {
      const images = sources.links
      filteredMemories.push({
        thumbnail: images['image-thumbnail'].href,
        full: images.image.href,
        resourceId: contributor,
        id: sources.id,
      })
    }
    if (sources.mediaType.slice(0, 10).toLowerCase() === 'text/plain' && memoryType === 'text/plain') {
      // text story
      const title = sources && sources.titles && sources.titles.length > 0 ? sources.titles[0].value : ''
      const description =
        sources && sources.descriptions && sources.descriptions.length > 0 ? sources.descriptions[0].value : ''
      const link = sources.about

      filteredMemories.push({ title, description, link, resourceId: contributor, id: sources.id })
    }
    if (sources.mediaType.slice(0, 15).toLowerCase() === 'application/pdf' && memoryType === 'application/pdf') {
      // pdf story

      const title =
        sources.titles && sources.titles.length > 0 && sources.titles[0].value ? sources.titles[0].value : ''

      const link = sources.about
      const thumb = sources.links['image-thumbnail'].href
      filteredMemories.push({ title, thumb, link, resourceId: contributor, id: sources.id })
    }
    if (sources.mediaType.slice(0, 5).toLowerCase() === 'audio' && memoryType === 'audio') {
      const title = sources.titles && sources.titles.length > 0 ? sources.titles[0].value : ''
      const link = sources.about
      filteredMemories.push({ title, link, resourceId: contributor, id: sources.id })
    }
  })

  return filteredMemories
}
